module.exports = __webpack_public_path__ + "img/book2-4.03fddc88.jpg";